import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-advisory-committee',
  templateUrl: './advisory-committee.component.html',
  styleUrls: ['./advisory-committee.component.scss']
})
export class AdvisoryCommitteeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
